import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataCustomData } from '@onefootprint/request-types/dashboard';
import type { TemplateInputProps } from '@onefootprint/ui';
import PlaybookCustomQuestions, { type CustomQuestionsFormData, convertToApiPayload, convertToFormData } from '@/features/playbook-custom-questions';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import { useGetNodeConfigContext } from '../../hooks/use-get-node-config-context';
import BaseNode, { type ApplyEditMutation } from '../base-node';
export const CustomDataNode = node => {
  const $ = _c(18);
  const {
    id
  } = node;
  const config = useGetNodeConfigContext(id, "templatable");
  let t0;
  if ($[0] !== config?.autocomplete) {
    t0 = Object.entries(config?.autocomplete || {}).reduce(_temp2, {} as TemplateInputProps['autocompleteItems']);
    $[0] = config?.autocomplete;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const autocompleteItems = t0;
  let t1;
  if ($[2] !== node.data.page) {
    t1 = convertToFormData(node.data.page);
    $[2] = node.data.page;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== node.data.confirmationMode || $[5] !== t1) {
    t2 = {
      ...t1,
      confirmationMode: node.data.confirmationMode
    };
    $[4] = node.data.confirmationMode;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const defaultValues = t2;
  let t3;
  if ($[7] !== node.id) {
    t3 = async (data, mutation) => {
      ;
      try {
        await mutation.mutateAsync({
          kind: "update_node",
          nodeData: {
            kind: "collect_custom_data",
            page: convertToApiPayload(data),
            confirmationMode: data.confirmationMode
          },
          nodeId: node.id
        });
      } catch (t4) {
        const error = t4;
        console.error("Error updating playbook session:", error);
      }
    };
    $[7] = node.id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSubmit = t3;
  let t4;
  if ($[9] !== autocompleteItems || $[10] !== defaultValues || $[11] !== handleSubmit || $[12] !== node.data.subject) {
    t4 = {
      render: t5 => {
        const {
          mutation: mutation_0,
          canEdit
        } = t5;
        return <PlaybookCustomQuestions defaultValues={defaultValues} onSubmit={data_0 => handleSubmit(data_0, mutation_0)} autocompleteItems={autocompleteItems} canEdit={canEdit} subject={node.data.subject} />;
      },
      form: "custom-questions-form",
      size: "xl"
    };
    $[9] = autocompleteItems;
    $[10] = defaultValues;
    $[11] = handleSubmit;
    $[12] = node.data.subject;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== id || $[15] !== node.data || $[16] !== t4) {
    t5 = <BaseNode nodeId={id} data={node.data} sidebar={t4} />;
    $[14] = id;
    $[15] = node.data;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
function _temp(item) {
  return {
    label: item.display,
    value: item.token,
    detail: item.dataType.join(" | ")
  };
}
function _temp2(acc, t0) {
  const [key, value] = t0;
  acc[key === "workflowContextKeys" ? "others" : key] = value.map(_temp);
  return acc;
}